import { useState, useEffect } from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import MessageCard from "./message-card";
import { getMyConversation } from "../../apis/feedback/get.my.conversation";
import { Conversation } from "../../types/feedback";

const Messages = () => {
  const navigate = useNavigate();
  const [conversation, setConversation] = useState<Conversation | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMyConversation(
      {
        onCompleted({ data }) {
          setConversation(data);
          setLoading(false);
        },
        onError() {
          setLoading(false);
        },
      },
      { bypassCache: true }
    );
  }, []);

  const getTimeAgo = (dateString: string) => {
    const diffInMs = Date.now() - new Date(dateString).getTime();
    const diffInMins = Math.floor(diffInMs / 60000);
    const diffInHours = Math.floor(diffInMs / 3600000);
    const diffInDays = Math.floor(diffInMs / 86400000);
    if (diffInMins < 1) return "Just now";
    if (diffInMins < 60) return `${diffInMins} min${diffInMins > 1 ? "s" : ""} ago`;
    if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
    if (diffInDays < 7) return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    return new Date(dateString).toLocaleDateString();
  };

  const messages = conversation?.messages ?? [];
  const last = messages[messages.length - 1];
  // Unread for the customer = the most recent message is an admin reply.
  const unread = last?.sender === "admin";

  return (
    <div className="flex flex-col gap-3 h-screen w-full px-5">
      <div className="flex items-center w-full py-5 relative">
        <button
          onClick={() => navigate("/support")}
          className="absolute left-0 p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <ChevronLeft size={24} className="text-gray-900" />
        </button>
        <h1 className="text-[32px] font-[400] w-full text-center optima">
          Messages
        </h1>
      </div>

      {loading ? (
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <p className="text-gray-400 text-sm glacial">Loading…</p>
        </div>
      ) : messages.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <p className="text-gray-400 text-lg glacial">No messages yet</p>
          <p className="text-gray-400 text-sm glacial mt-2">
            Your conversation with Weddn support will appear here
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          <MessageCard
            issueType="Weddn Support"
            lastMessage={last?.body || ""}
            timeAgo={getTimeAgo(last?.createdAt || "")}
            unread={unread}
            onClick={() => navigate("/send-a-message")}
          />
        </div>
      )}
    </div>
  );
};

export default Messages;
